import React from 'react';

const Section = (props) => {
  return (
    <div>
      {/* Vehicle display section has been removed since booking is handled in Hero component */}
    </div>
  );
};

export default Section;